/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, getOr } from 'lodash/fp';
import t from 'app/utils/translate';
import FullPage from 'app/containers/parts/FullPage';
import CustomHelmet from 'app/components/commons/CustomHelmet';
import HowToPlayHead from 'app/components/static/HowToPlayHead';
import HowToPlayContent from 'app/components/static/HowToPlayContent';
import HowToPlaySteps from 'app/components/static/HowToPlaySteps';

type Props = {
  bannerMobile: string,
  bannerDesktop: string,
  pages: Array<Object>,
  tagline?: string,
  htmlTitle?: string,
  description?: string
};

class HowToPlay extends Component<Props> {
  props: Props;

  references: Array<Object> = []; // eslint-disable-line react/sort-comp

  static defaultProps = {
    tagline: undefined,
    htmlTitle: undefined,
    description: undefined
  };

  handleClick = index => {
    const target = this.references[index];

    if (!target) {
      return;
    }

    window.scrollTo({
      top: target.offsetTop,
      behavior: 'smooth'
    });
  };

  handleRef = (index: number, ref: Object) => {
    this.references[index] = ref;
  };

  render() {
    const { pages, tagline, bannerMobile, bannerDesktop, htmlTitle, description } = this.props;

    return (
      <FullPage>
        <CustomHelmet description={description} htmlTitle={htmlTitle} title={t('How to play')} />
        <HowToPlayHead tagline={tagline} desktopImage={bannerDesktop} mobileImage={bannerMobile} />
        <HowToPlaySteps onClick={this.handleClick} steps={pages} />
        <HowToPlayContent onInnerRef={this.handleRef} pages={pages} />
      </FullPage>
    );
  }
}

function mapStateToProps({ settings }) {
  const pages = getOr([])('content.howToPlay.pages')(settings);
  return {
    bannerDesktop: get('content.howToPlay.bannerDesktop')(settings),
    bannerMobile: get('content.howToPlay.bannerMobile')(settings),
    pages,
    tagline: get('content.howToPlay.tagline')(settings),
    htmlTitle: get('content.howToPlay.htmlTitle')(settings),
    description: get('content.howToPlay.description')(settings)
  };
}

export default connect(mapStateToProps)(HowToPlay);
